import { StyleSheet } from 'aphrodite';
import typography from 'defaults/typography';
import { hexToRgbA } from 'utils/styleUtil';

//All color and font related changes here. The layout will be in .scss file

const getSkin = (theme) => {
    const skin = theme.globalProfiles.palette;
    const myTypography = typography(theme);

    return StyleSheet.create({
        outsideContainer: {
            ...myTypography.timer,
            border: `0.9px solid ${skin.white}`
        },
        container: {
            background: skin.white,
            color: skin.primaryColor
        }
    });
}

export default getSkin;
